import { useState, useEffect } from 'react'

/**
 * Es un componente que toma un objeto con tres propiedades y devuelve un campo de entrada con una etiqueta y un mensaje de error.
 * @returns Un componente que representa un campo de entrada con una etiqueta y un mensaje de error si hay un error.
 */
const TextArea = ({
  inputLabel = 'inputLabel',
  inputField,
  required,
  changingInput,
  disabled,
  readOnly,
  extraStyle = "",
  rows,
  id
}) => {

  const [val, setVal] = useState(inputField);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    setVal(inputField);
  }, [inputField]);

  useEffect(() => {
    if (val) {
        setIsFocused(true)
    } else {
        setIsFocused(false)
    }
  }, [val])

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (event) => {
    val ? setIsFocused(true): setIsFocused(false);
  };


  const handleOnChangeInput = (e) => {
    setVal(e.target.value);
    changingInput(e);
  }

  return (
    <div className={`form-group ${isFocused ? "focused" : ""}`}>
      <label className="form-label" htmlFor={id}>
        {inputLabel}
      </label>
       
        <textarea
        id={id}
        className={`form-input ${extraStyle !== "" ? extraStyle : ""}`}
        type="text"
        onFocus={handleFocus}
        onBlur={handleBlur}
        name={inputLabel}
        value={val}
        onChange={handleOnChangeInput}
        required={required}
        disabled={disabled}
        readOnly= {readOnly}
        autoComplete='off'
        rows={rows}
      />
       
    </div>
  )
}

export default TextArea
